export default __webpack_public_path__ + "4919baa34b023e32e0d9fd40903d5227.svg";